import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import PageHelmet from '@bd/bdcore-pagehelmet';
import InsideHeader from '../../components/InsideHeader';
import FYHMenu from '../../components/menus/FYH';
import PageWrapper from '../../components/PageWrapper';
// import HomesResults from './HomesResults';
// import Filters from '../../components/Filters';
import ContentSection from './ContentSection';
import ContactBanner from '../../components/ContactBanner';


const styles = css`
  background-color: #000000;
  @media (max-width: 767.98px) {
    .InsideHeader + div { /* menuToggler wrapper around InternalMenu (FYHMenu) */
      display: none;
    }
  }
  .InsideHeader + div + div { /* menuToggler wrapper around Filters component */
    display: inline-block;
  }
  .Homes_content {
    padding: 40px 20px 70px;
    @media (min-width: 768px) {
      padding: 50px 40px 110px;
    }
    @media (min-width: 992px) {
      padding: 50px 90px 125px;
    }
    @media (min-width: 1280px) {
      padding-left: 150px;
      padding-right: 150px;
    }
  }
  .Homes_contentInner {
    @media (min-width: 1440px) {
      max-width: 1600px;
      margin-left: auto;
      margin-right: auto;
    }
  }
  .Homes_filtersRow {
    @media (max-width: 619.98px) {
      justify-content: center;
    }
    @media (min-width: 620px) and (max-width: 767.98px) {
      margin-left: -7.5px;
      margin-right: -7.5px;
    }
  }
`;


function Homes({ builder, widget }) {
  const pageHeader = get(widget, 'page_title');
  const pageSubtitle = get(widget, 'page_subtitle');
  const pageImage = get(widget, 'page_image.contentUrl');
  const metaTitle = 'New Construction Homes in Broken Arrow, OK';
  const metaDescription = 'View all available homes in our master-planned community, Forest Ridge, in Broken Arrow, OK.';

  return (
    <PageWrapper className={styles} builder={builder}>
      <PageHelmet
        custom
        title={metaTitle}
      >
        <meta property="og:description" content={metaDescription} />
        <meta property="og:image" content={buildThumbnailUrl(pageImage, { width: 1200, height: 1200 })} />
        <meta property="og:title" content={pageHeader} />
        <meta name="description" content={metaDescription} />
      </PageHelmet>
      <InsideHeader
        title={pageHeader}
        subTitle={pageSubtitle}
        background={pageImage}
      />
      <FYHMenu />
      <main className="container">
        <ContentSection />
      </main>
      <ContactBanner />
    </PageWrapper>
  );
}

Homes.propTypes = {
  builder: PropTypes.object.isRequired,
  widget: PropTypes.object.isRequired,
};

export default withData({
  builder: true,
  widget: 'homes',
})(Homes);



// WEBPACK FOOTER //
// ./src/pages/Homes/index.js